
const MapSection = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center">
          <i className="ri-map-pin-line text-red-600 mr-3"></i>
          Visit Our Office
        </h2>
        <p className="text-gray-600 mt-2">
          Located in the heart of Doha, we're easily accessible for consultations and meetings.
        </p>
      </div>
      
      <div className="relative h-80">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d462560.6174049934!2d51.069!3d25.276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e45c534ffdce87f%3A0x44d2061f8f86d6df!2sDoha%2C%20Qatar!5e0!3m2!1sen!2s!4v1635000000000!5m2!1sen!2s"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="FlameGuardQA Office Location"
        />
        
        <div className="absolute top-4 left-4 bg-white rounded-lg shadow-lg p-3">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-red-600 rounded-full"></div>
            <span className="text-sm font-medium text-gray-900">FlameGuardQA</span>
          </div>
          <p className="text-xs text-gray-600 mt-1">Fire Safety Solutions</p>
        </div>
      </div>
      
      <div className="p-4 bg-gray-50">
        <div className="flex items-center justify-between text-sm text-gray-600">
          <span>📍 Doha, Qatar</span>
          <a 
            href="https://maps.google.com/?q=Doha,Qatar" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-red-600 hover:text-red-700 font-medium"
          >
            Get Directions →
          </a>
        </div>
      </div>
    </div>
  );
};

export default MapSection;
